var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"71","height":"11","fill":"url(#pattern0)","key":0}),React.createElement("defs",{"key":1},[React.createElement("pattern",{"id":"pattern0","patternContentUnits":"objectBoundingBox","width":"1","height":"1","key":0},React.createElement("use",{"xlinkHref":"#image0","transform":"scale(0.0140845 0.0909091)"})),React.createElement("image",{"id":"image0","width":"71","height":"11","xlinkHref":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAAALCAYAAAAtKpAIAAAAAXNSR0IArs4c6QAAAKxJREFUSEvt1j0OgVEUhOF3dqSzDfkiOjqNUiREL2hVGq1OpbAPK7AOIUeO78ctLGHuEp7MzLnCj4g4AAtJz5JDtiFxHsAdGJZAxuGLswR2wBWoJL0yNMZpqhMRK2ALnIGJpLciYuBqdQIVMAYuwChxwjh/BfqJ0zNOJzBvknMCpt6c3+bkIOcwH4GZpDBOfa02wLqE8bX6pSb/Obc2MW3JnJw6OXnG91mlcn8/N0I8PIIBHCEAAAAASUVORK5CYII=","key":1})])]);
}

Arrow.defaultProps = {"width":"71","height":"11","viewBox":"0 0 71 11","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
